<template>
<div>
    <div class="form-group">
        <label for="username">{{usernameLabel.username}}</label>
        <input id="username" aria-required="true" :aria-describedby="getUsernameElementId('requirement')" type="text" class="form-control" v-bind:class="{'error': inUsernameError || (createUser && usernameValue != '' && !allRequirementsMet)}" :name="name" :maxlength="clientProfile.userIdMaxLength" v-model="usernameValue" @blur="onUsernameBlur">
        <p v-if="createUser && inUsernameError" class="error-msg mt-1 mb-1" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{usernameLabel.requiredEntry}}</p>
        <div class="d-flex justify-content-center"><a v-if="displayForgotUserLink" class="mt-3" :action="forgotUserAction" href="" @click="displayForgotUser">{{forgotUserLabel}}</a></div>
        <template v-if="createUser">
            <span v-if="allRequirementsMet" class="sr-only" role="alert" aria-live="assertive">{{usernameLabel.userRequirementMet}}</span>
            <span v-else class="sr-only" role="alert" aria-live="assertive">{{usernameLabel.userRequirementNotMet}}</span>
            <div class="col-12 px-0 my-3">
                <p class="font-weight-bold">{{requirementsLabel}}</p>
                <span class="sr-only" :id="getUsernameElementId('requirement')">{{unmatchedRequirement}}</span>
                <ul class="userRquirements">
                <template v-for="requirement in requirements">
                    <li :aria-hidden="String(requirementsMet[requirement.type].valid != 'info')" v-if="requirementsMet[requirement.type].display" class="m-0">
                        <span v-if="requirementsMet[requirement.type].valid == true"><fa-icon :icon="['fas','check-circle']" class="met"></fa-icon></span>
                        <span v-else-if="requirementsMet[requirement.type].valid == false"><fa-icon :icon="['fas','times-circle']" class="unmet"></fa-icon></span>
                        <span v-else><fa-icon :icon="['fas','info-circle']" class="info"></fa-icon></span>
                        {{substitution(requirement.text)}}
                    </li>
                </template>
                </ul>
            </div>
        </template>
    </div>
    <div class="form-group" v-if="createUser">
        <label for="confirmUsernameValue">{{usernameLabel.confirmUsername}}</label>
        <input id="confirmUsernameValue" aria-required="true" v-bind:class="{'error': inConfirmUsernameError}" type="text" class="form-control" name="confirmusername" @blur="onConfirmUsernameBlur" v-model="confirmUsernameValue">
        <p v-if="inConfirmUsernameError" class="error-msg mt-1 mb-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{inConfirmUsernameError}}</p>
    </div>
</div>
</template>

<script>
import debounce from "lodash/debounce";

    let instanceCount = 0;
    export default {
        name: "Username",

        emits: ['set-username', 'forgot-user-id'],

        data: function() {
            return {
                usernameValue: "",
                confirmUsernameValue: "",
                allRequirementsMet: false,
                requirementsMet: {},
                inUsernameError: null,
                inConfirmUsernameError: null,
                requirements: this.getUsernameRequirements(),
                instanceId: `user-requirements-${instanceCount++}`,
                unmatchedRequirement: ""
            }
        },

        props: {
            name: {
                type: String,
                default: "username"
            },
            usernameLabel: Object,
            forgotUserLabel: String,
            forgotUserAction: String,
            displayForgotUserLink: {
                type: Boolean,
                default: false
            },
            createUser: {
                type: Boolean,
                default: false
            },
            requirementsLabel: String
        },

        methods: {
            getUsernameElementId: function(type) {
             return `${this.instanceId}-${type}`;
            },

            setValue: function(value) {
                this.usernameValue = value;
            },
            
            getValue: function() {
                return this.usernameValue;
            },

            displayForgotUser: function(e) {
                e.preventDefault();
                this.$emit(e.target.attributes.action.value);
            },

            clear: function() {
                this.usernameValue = "";
                this.confirmUsernameValue = "";
                this.inUsernameError = null;
                this.inConfirmUsernameError = null;
            },

            isUsernameValid: function() {
                return this.usernameValue !== "";
            },

            isConfirmUsernameValid: function() {
                if(this.confirmUsernameValue === "")
                    return this.usernameLabel.requiredEntry;
                else if(this.confirmUsernameValue !== this.usernameValue)
                    return this.usernameLabel.usernameNotMatched;
                return true;
            },

            onUsernameBlur: function(){
                this.setInUsernameError();
                if(this.createUser && this.confirmUsernameValue != "")
                    this.setInConfirmUsernameError();
            },

            onConfirmUsernameBlur: function() {
               this.setInConfirmUsernameError();
            },

            setInUsernameError: function(){
                this.inUsernameError = !(this.isUsernameValid());
            },

            setInConfirmUsernameError: function(){
                var isValid = this.isConfirmUsernameValid();
                this.inConfirmUsernameError = isValid === true ? false : isValid;
            },

            validateAndEmitUsername: function () {
                this.emitUsername(this.allRequirementsMet && this.isUsernameValid() && this.isConfirmUsernameValid() === true ? this.usernameValue : "");
            },

            emitUsername: function (val) {
                this.$emit('set-username', val);
            },
            
            substitution: function(item) {
                var parts = item.split(/(?<!\\)#/);
                for (var i=1; i < parts.length; i+=2) {
                    parts[i] = this.clientProfile[parts[i]];
                }
                return parts.join('').replace(/\\#/g, '#');
            },            

            validateUsername: function() {
                for (var requirement in this.requirementsMet) {
                    let requirementDetails = this.requirementsMet[requirement];
                    if (requirementDetails.display && requirementDetails.valid != "info") {
                        this.setRequirementValid(requirement, requirementDetails.validate(requirement));
                    }
                }
            },

            setRequirementValid: function(requirementType, valid) {
                var requirementDetails = this.requirementsMet[requirementType];
                requirementDetails.valid = valid == null ? requirementDetails.valid : valid;
            },

            validateLength: function() {
                return this.clientProfile.userIdMinLength <= this.usernameValue.length && this.usernameValue.length <= this.clientProfile.userIdMaxLength;
            },

            validateMinAlpha: function() {
                var regex = new RegExp(/[a-zA-Z]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinAlphabeticCharactersCount;
            },

            validateMinNumeric: function() {
                var regex = new RegExp(/[0-9]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinNumericCharactersCount;
            },

            validateMinSpecial: function() {
                var regex = new RegExp(/[^a-zA-Z0-9]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinSpecialCharactersCount;
            },

            validateMinNonAlpha: function() {
                var regex = new RegExp(/[^a-zA-Z]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinNonAlphabeticCharactersCount;
            },

            validateMinNonNumeric: function() {
                var regex = new RegExp(/[^0-9]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinNonNumericCharactersCount;
            },

            validateMinNonSpecial: function() {
                var regex = new RegExp(/[a-zA-Z0-9]/g);
                var match = this.usernameValue.match(regex);
                return match !== null && match.length >= this.clientProfile.userIdMinNonSpecialCharCount;
            },

            validateSpaces: function() {
               var hasSpaces = this.usernameValue.includes(" ");
               return !hasSpaces;
            },

            addRequirement: function(key, display, valid, callback, callbackTimeout) {
                var boundCallback = callback && this[callback].bind(this);
                var item = {
                    "display": display,
                    "valid": valid,
                    "validate": callbackTimeout ? debounce(boundCallback, callbackTimeout) : boundCallback
                };

                Object.assign(this.requirementsMet, {[key]: item});
            }
        },

        watch: {
            requirementsMet: {
                deep: true,
                handler: function(val) {                    
                    var allRequirementsMet = true;
                    var unmatchedRequirement = [];

                    for (var requirement in val) {
                        if (val[requirement].display && val[requirement].valid === false) {
                            allRequirementsMet = false;
                            unmatchedRequirement.push(this.substitution(
                            this.requirements.find(({type}) => type == requirement).text
                            ));
                        }
                    }

                    this.allRequirementsMet = allRequirementsMet;
                    this.unmatchedRequirement = unmatchedRequirement.join(';');
                }
            },

            usernameValue: function (val) {
                if(this.createUser) {
                    this.validateUsername();
                    this.inUsernameError = false;
                    this.inConfirmUsernameError = false;
                    this.validateAndEmitUsername(val);
                } else {
                    this.setInUsernameError();
                    this.emitUsername(val);
                }
            },

            confirmUsernameValue: function (val) {
                this.inConfirmUsernameError = false;
                this.validateAndEmitUsername(val);
            },

            allRequirementsMet: function() {
                this.validateAndEmitUsername();
            }
        },

        created: function() {
            this.clientProfile = this.getClientProfile();
            this.addRequirement('length', true, false, "validateLength");
            this.addRequirement('minAlpha', this.clientProfile.userIdMinAlphabeticCharactersCount > 0, false, "validateMinAlpha");
            this.addRequirement('minNumeric', this.clientProfile.userIdMinNumericCharactersCount > 0, false, "validateMinNumeric");
            this.addRequirement('minSpecial', this.clientProfile.userIdMinSpecialCharactersCount > 0, false, "validateMinSpecial");
            this.addRequirement('minNonAlpha', this.clientProfile.userIdMinNonAlphabeticCharactersCount > 0, false, "validateMinNonAlpha");
            this.addRequirement('minNonNumeric', this.clientProfile.userIdMinNonNumericCharactersCount > 0, false, "validateMinNonNumeric");
            this.addRequirement('minNonSpecial', this.clientProfile.userIdMinNonSpecialCharCount > 0, false, "validateMinNonSpecial");
            this.addRequirement('allowSpecial', this.clientProfile.userIdMinSpecialCharactersCount == 0, "info");
            this.addRequirement('noSsn', true, 'info');
            this.addRequirement('noSpaces', true, false, "validateSpaces");
            this.addRequirement('caseInSensitive', true, "info");
        },

        inject: [
            'getClientProfile',
            'getUsernameRequirements'
        ]
    }
</script>



<style scoped>
    .met {
        color: #43a047;
    }

    .unmet {
        color: var(--priority-color);
    }

    .userRquirements{
        font-size: 14px;
    }
</style>